export function formatNumber(num: number) {
    let numToStr = num.toString();

    if (num <= 999) {
        return numToStr;
    }

    if (num <= 999999) {
        return `${Math.round(num / 1000)}K`;
    }

    return `${Math.round(num / 1000000)}M`;
}
